import { FieldValues, UseFormReturn } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { InputGroup } from 'shared/molecules'

type SocialFieldsProps = {
	form: UseFormReturn<FieldValues>
}

export const SocialFields = ({ form }: SocialFieldsProps) => {
	const { t } = useTranslation()
	const { register } = form

	const networks = [
		{ name: 'facebook_url', label: t('Facebook') },
		{ name: 'twitter_url', label: t('Twitter') },
		{ name: 'instagram_url', label: t('Instagram') },
		{ name: 'pinterest_url', label: t('Pinterest') },
		{ name: 'linkedin_url', label: t('LinkedIn') }
	]

	return (
		<>
			{networks.map(({ name, label }) => (
				<InputGroup key={name} id={name} type="url" label={label} {...register(name)} />
			))}
		</>
	)
}
